export default __webpack_public_path__ + "static/media/line-h-20.09e96505.png";